import { render } from "./payment-field.vue?vue&type=template&id=238efad3&scoped=true"
import script from "./payment-field.vue?vue&type=script&lang=js"
export * from "./payment-field.vue?vue&type=script&lang=js"

import "./payment-field.vue?vue&type=style&index=0&id=238efad3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238efad3"]])

export default __exports__